module.exports = __webpack_public_path__ + "img/tips-send.ea03a8d2.svg";